import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RoomService } from '../live-viewer/room.service';
import { ActivatedRoute } from '@angular/router';
import { IProduct } from '../model/room.model';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent {

  constructor(private roomService: RoomService) {
  }

  @Input("products") products: IProduct[];
  @Output("onProductClosed") onProductClosed = new EventEmitter<any>();

   closeDialog() {
      this.onProductClosed.emit(true);
   }

}
